import React, { useState, useEffect } from 'react';
import Toast from './Toast';
import toastService from '../../services/toastService';
import './Toast.css';

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsubscribe = toastService.subscribe(setToasts);
    return unsubscribe;
  }, []);

  const handleCloseToast = (toastId) => {
    toastService.remove(toastId);
  };

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={handleCloseToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;